// extracted by mini-css-extract-plugin
module.exports = {"label":"Chip_label__XGa1T","selected":"Chip_selected__dLMQZ"};